import type { RouteObject } from 'react-router';

// Route children — defined once, mounted at different paths based on subdomain
const mainChildren: RouteObject[] = [
	{ index: true, lazy: async () => import('./pages/HomePage.js') },
	{ path: 'login', lazy: async () => import('./pages/auth/LoginPage.js') },
	{ path: 'signup', lazy: async () => import('./pages/auth/SignupPage.js') },
	{ path: 'settings/security', lazy: async () => import('./pages/auth/SecuritySettingsPage.js') },
	{ path: 'forgot-password', lazy: async () => import('./pages/auth/ForgotPasswordPage.js') },
	{ path: 'reset-password', lazy: async () => import('./pages/auth/ResetPasswordPage.js') },
	{ path: 'verify-email', lazy: async () => import('./pages/auth/VerifyEmailPage.js') },
	{ path: 'verify-2fa', lazy: async () => import('./pages/auth/TwoFactorVerifyPage.js') },
];

const adminChildren: RouteObject[] = [
	{ index: true, lazy: async () => import('./pages/admin/DashboardPage.js') },
	{ path: 'users', lazy: async () => import('./pages/admin/UsersPage.js') },
	{ path: 'feature-flags', lazy: async () => import('./pages/admin/FeatureFlagsPage.js') },
	{ path: 'translations', lazy: async () => import('./pages/admin/TranslationsPage.js') },
	{ path: 'settings', lazy: async () => import('./pages/admin/SettingsPage.js') },
];

export function createRoutes(routePrefix = '/'): RouteObject[] {
	if (routePrefix === '/admin') {
		return [{ path: '/', lazy: async () => import('./layouts/AdminLayout.js'), children: adminChildren }];
	}

	return [
		{ path: '/', lazy: async () => import('./layouts/MainLayout.js'), children: mainChildren },
		{ path: '/admin', lazy: async () => import('./layouts/AdminLayout.js'), children: adminChildren },
	];
}

export const routes = createRoutes();
